import React from 'react';
import '../css/Profile.css';
import firebase from 'firebase';
import moment from 'moment';

import { Link } from 'react-router-dom';

class Profile extends React.Component {
  state = {
    user: null,
    userArray: [],
    flag: 0,
  }
  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      console.log(user);
      if(user) {
        this.setState({user: user})
        document.getElementById("logout").style.display="inline";
        document.getElementById("login-google").style.display="none";
      }
      else {
        document.getElementById("logout").style.display="none";
        document.getElementById("login-google").style.display="inline";
      }
    });
    firebase
      .firestore()
        .collection('users')
          .onSnapshot((result) => {
            console.log(result);
            let docs = result.docs;
            let users = docs.map((doc, pos) => {
              let data = doc.data();
              data.id = doc.id;
              return data;
            });
            this.setState({
              userArray: users,
            });
            console.log(this.state.userArray);
          })
  }
  render() {
    let name = this.getName(this.state.user);
    let obj = null;
    console.log(name);
    if(this.state.userArray && this.state.user) {
      for(var i = 0; i<this.state.userArray.length; i++) {
        if(this.state.user.uid == this.state.userArray[i].uid && this.state.userArray[i].hotel) {
          console.log(moment().format('YYYY-MM-DD'));
          console.log(this.state.userArray[i].checkOut);
          if(moment().format('YYYY-MM-DD')<=this.state.userArray[i].checkOut) {
          obj = {
            hotel: this.state.userArray[i].hotel,
            checkIn: this.state.userArray[i].checkIn,
            checkOut: this.state.userArray[i].checkOut,
          }
        } else {
          firebase.firestore().collection('users').doc(this.state.user.uid).set({
            name: this.state.user.displayName,
            uid: this.state.user.uid,
            email: this.state.user.email,
          });
        }
          break;
        }
      }
    }
    if(this.state.user && obj) {
      return(
        <div className="profileParent">
              <div className="sign-in-form">
                <h2>Welcome {name}!</h2>
                <div>
                  <img className="quotes" src="./quote-gif.gif" width="1080px" height="720px"/>
                </div>
                <br />
                <div id="hotelBooked" className="belowImageText">
                  <h3>Your Bookings:</h3>
                  <p><span>Hotel booked: </span>{obj.hotel}</p>
                  <p><span>Check-in date: </span>{obj.checkIn}</p>
                  <p><span>Check-out date: </span>{obj.checkOut}</p>
                </div>
                <br />
                <button type="button" id="login-google" name="login-google" onClick={this.onGoogleClick}>Login using Google</button>
                <br />
                <button type="button" id="logout" onClick={this.logOut}>Log-Out</button>
                </div>
            </div>
      );
    } else {
      return(
          <div className="profileParent">
                <div className="sign-in-form">
                  <h2>Welcome {name}!</h2>
                  <div>
                    <img className="quotes" src="./quote-gif.gif" width="1080px" height="720px"/>
                  </div>
                  <br />
                  <div id="hotelBooked" className="belowImageText">
                    <h3>No bookings found. Want to book a hotel...?</h3>
                    <Link to="/hotels">Click here!</Link>
                  </div>
                  <br />
                  <button type="button" id="login-google" name="login-google" onClick={this.onGoogleClick}>Login using Google</button>
                  <br />
                  <button type="button" id="logout" onClick={this.logOut}>Log-Out</button>
                  </div>
              </div>
        );
    }
  }
  onGoogleClick = () => {
    let provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
        .then(result => {
          let user = result.user;
          this.updateUserState(user);
          this.checkUser(user);
        })
        .catch(err => {
          console.error(err);
        })
  }
  updateUserState = (user) => {
    console.log(this.state.userArray);
    console.log(user);
    let data = null;
    for(var i = 0; i<this.state.userArray.length; i++) {
      console.log(this.state.userArray[i]);
      if(this.state.userArray[i].uid == user.uid) {
        console.log("Found user");
        this.setState({flag: 1});
        alert("Logged in successfully");
        if(this.state.userArray[i].hotel){
          data = {
            name: user.displayName,
            uid: user.uid,
            email: user.email,
            hotel: this.state.userArray[i].hotel,
            checkIn: this.state.userArray[i].checkIn,
            checkOut: this.state.userArray[i].checkOut,
          }
        } else {
            data = {
              name: user.displayName,
              uid: user.uid,
              email: user.email,
            }
          }
          this.setState({user: data});
          break;
        } else {
          this.setState({flag: 0});
        }
    }
    console.log(data);
    console.log(this.state.user);
  }
  logOut = () => {
    firebase.auth().signOut();
    window.location.reload();
  }
  checkUser = (user) => {
    console.log(user);
    if(this.state.flag == 0) {
      let data = {
        email: user.email,
        name: user.displayName,
        uid: user.uid,
      }
      this.setState({user: data});
      firebase.firestore().collection('users').doc(user.uid).set({
        email: user.email,
        name: user.displayName,
        uid: user.uid,
      });
    }
    console.log(user);
  }
  getName = (user) => {
    if(user) {
      return user.displayName;
    } else {
      return null;
    }
  }
}

export default Profile;
